module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_muotathal-3ad631b698338aabab9e798914a6dbdf.png";